<app-top-nav appNavVisibility/>
<app-custom-modal [modalOptions]="modalOptions"/>

<!-- Loading overlay while checking authentication -->
<div class="auth-loading-overlay" *ngIf="showLoadingOverlay">
	<div class="loading-content">
		<mat-spinner diameter="60" color="primary"></mat-spinner>
		<p class="loading-text">Loading...</p>
	</div>
</div>

<!-- Main content - only show when auth status is determined -->
<router-outlet *ngIf="!showLoadingOverlay"></router-outlet>

<!-- Global floating background task indicator -->
<app-background-task-indicator/>
